import Phaser from 'phaser'

export default class Preloader extends Phaser.Scene
{
	constructor()
	{
		super('preloader')
	}

	preload()
	{
		this.load.image('tiles', 'tiles/rpg_tiles.png')
		this.load.image('title', 'items/title.png')
		this.load.tilemapTiledJSON('dungeon', 'dungeons/dungeon-02.json')

		this.load.atlas('minting', 'character/minting.png', 'character/minting.json')
		this.load.atlas('treasure', 'items/treasure.png', 'items/treasure.json')
		this.load.atlas('coin', 'items/coin.png', 'items/coin.json')
		this.load.atlas('mempool', 'items/mempool.png', 'items/mempool.json')
		this.load.atlas('explosion', 'items/explosion.png', 'items/explosion.json')
		this.load.atlas('cube', 'items/cube.png', 'items/cube.json')

		const characters = ['alchemist', 'barmaid', 'bartender', 'blacksmith', 'farmer', 'fisherman', 'kid01', 'kid02', 'merchant', 'minter'];
		characters.forEach(c => this.load.atlas(c, `character/${c}.png`, `character/${c}.json`))
		this.load.atlas('bubble', 'items/bubble.png', 'items/bubble.json')
		this.load.image('ui-heart-empty', 'ui/ui_heart_empty.png')
		this.load.image('ui-heart-full', 'ui/ui_heart_full.png')
		this.load.image('knife', 'weapons/weapon_knife.png')
		this.load.image('slot', 'items/slot.png')
	}

	create()
	{
		this.scene.start('title')
	}
}
